"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Layer = _interopRequireDefault(require("./Layer"));

var _utils = require("../../../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var GoogleTileLayer =
/** @class */
function (_super) {
  __extends(GoogleTileLayer, _super);

  function GoogleTileLayer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GoogleTileLayer.prototype.setOpacity = function (value) {
    _super.prototype.setOpacity.call(this, value);

    if (this.renderable) {
      this.renderable.setOpacity(value);
    }
  };

  GoogleTileLayer.prototype.setZIndex = function (index) {
    if (this.map && this.renderable) {
      var overlayIndex = this.map.overlayMapTypes.getArray().indexOf(this.renderable);

      if (overlayIndex !== -1) {
        this.map.overlayMapTypes.removeAt(overlayIndex);
        this.map.overlayMapTypes.insertAt(index, this.renderable);
      }
    }
  };

  GoogleTileLayer.prototype.updateVisibility = function (visible) {
    if (this.renderable) {
      this.renderable.setOpacity(visible ? this.opacity : 0);
    }
  };

  GoogleTileLayer.prototype.setUrl = function (url) {
    this.opts.url = url;

    if (this.map) {
      this.invalidate();
    }
  };

  GoogleTileLayer.prototype.invalidate = function () {
    var _this = this;

    var map = this.map;
    this.remove();
    setTimeout(function () {
      if (_this.enabled) {
        _this.addTo(map);
      }
    }, 200);
  };

  GoogleTileLayer.prototype.createRenderable = function () {
    var _this = this;

    var renderable = new google.maps.ImageMapType({
      name: this.id,
      opacity: this.opacity,
      tileSize: new google.maps.Size(256, 256),
      getTileUrl: function (tileCoord, zoom) {
        var url = _this.opts.url;

        if (!(0, _utils.isset)(url)) {
          return null;
        }

        var vars = {
          x: tileCoord.x,
          y: tileCoord.y,
          z: zoom,
          s: Math.abs(tileCoord.x + tileCoord.y) % 4 + 1
        };
        Object.keys(vars).forEach(function (k) {
          url = url.replace(new RegExp("{" + k + "}"), "" + vars[k]);
        });
        return url;
      }
    });
    google.maps.event.addListenerOnce(renderable, 'tilesloaded', function () {
      _this.trigger('load', {
        overlay: renderable
      });
    });
    return renderable;
  };

  GoogleTileLayer.prototype.addToMap = function (map) {
    if (this.renderable) {
      if (this.opts.zIndex >= 0) {
        // const overlayArray = this.map.overlayMapTypes.getArray()
        map.overlayMapTypes.insertAt(this.opts.zIndex, this.renderable);
      } else {
        map.overlayMapTypes.push(this.renderable);
      }
    }
  };

  GoogleTileLayer.prototype.removeFromMap = function (map) {
    if (this.renderable) {
      google.maps.event.clearListeners(this.renderable, 'tilesloaded');
      var overlayIndex = this.map.overlayMapTypes.getArray().indexOf(this.renderable);

      if (overlayIndex !== -1) {
        this.map.overlayMapTypes.removeAt(overlayIndex);
      }
    }
  };

  return GoogleTileLayer;
}(_Layer.default);

var _default = GoogleTileLayer;
exports.default = _default;
module.exports = exports.default;